var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup163(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 47,
    viewBox: "0 0 55 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0874 -12.0561C83.0874 -1.61449 74.0442 7.32625 62.2847 7.32625C50.5251 7.32625 41.4819 -1.61449 41.4819 -12.0561C41.4819 -22.4978 50.5251 -31.4385 62.2847 -31.4385C74.0442 -31.4385 83.0874 -22.4978 83.0874 -12.0561Z",
    stroke: "white",
    strokeOpacity: 0.74,
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6576 -10.8726C99.6576 8.59049 82.8771 24.8437 61.5742 24.8437C40.2713 24.8437 23.4907 8.59049 23.4907 -10.8726C23.4907 -30.3356 40.2713 -46.5888 61.5742 -46.5888C82.8771 -46.5888 99.6576 -30.3356 99.6576 -10.8726Z",
    stroke: "#D7D7D7",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.963 -12.0561C120.963 17.4474 95.4135 41.8877 63.2314 41.8877C31.0493 41.8877 5.5 17.4474 5.5 -12.0561C5.5 -41.5597 31.0493 -66 63.2314 -66C95.4135 -66 120.963 -41.5597 120.963 -12.0561Z",
    stroke: "#D7D7D7",
    strokeOpacity: 0.17,
    strokeWidth: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163);
export default __webpack_public_path__ + "static/media/Group 163.5b53531ab261b50b8b82bb3c07927bdb.svg";
export { ForwardRef as ReactComponent };